import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { lmsRoutes } from "./routes";
import { getLmsLinks } from "./links";
import enUS from "./i18n/en-US";
import fr from "./i18n/fr";

export const LmsModule: HubModule = {
  id: "lms",
  name: "Learning",
  requiredFeature: "lms",
  landingPath: "/lms",
  landingPriority: 80,
  routes: (layouts) => lmsRoutes(layouts.MainLayout),
  navLinks: (ctx) => getLmsLinks(ctx),
  messages: { "en-US": enUS, fr },
};
